
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/dienstleistungen/ot-cybersecurity",
      function () {
        return require("private-next-pages/[locale]/dienstleistungen/ot-cybersecurity.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/dienstleistungen/ot-cybersecurity"])
      });
    }
  